export const lightTheme = {
  body: 'snow',
  text: 'black',
  link: '#97FFff',
  startLink: '#275D5D',
  headerText: '#275D5D',
  toggleBorder: '#000',
  background: 'timber',
}
export const darkTheme = {
  body: '#111013',
  text: '#FFF',
  link: '#97FFff',
  startLink: '#97FFff',
  headerText: '#97FFff',
  toggleBorder: '#CCC',
  background: '#999',
  viewport: '#141233',
  glow: '0 0 10px #afc, 0 0 20px #afc, 0 0 50px #e6cc73, 0 0 80px #e6cc73'
}

//Alternate theme colors can go here...